import { withMask } from './withMask';
import { RawInput } from './RawInput';
import {
    formatCnpj,
    parseCpf,
    parseCnpj,
    formatCpf,
    formatCep,
    parseCep,
    formatTel,
    parseTel,
    formatCpfCnpj,
    parseCpfCnpj
} from './index.utils';

export const InputText = RawInput;

export const InputCpf = withMask(RawInput, { format: formatCpf, parse: parseCpf });

export const InputCnpj = withMask(RawInput, { format: formatCnpj, parse: parseCnpj });

export const InputCep = withMask(RawInput, { format: formatCep, parse: parseCep });

export const InputTel = withMask(RawInput, { format: formatTel, parse: parseTel });

export const InputCpfCnpj = withMask(RawInput, { format: formatCpfCnpj, parse: parseCpfCnpj });

export * from './RawInput';
export * from './withMask';
export * from './index.utils';
